import AccessDeniedIcon from '@assets/images/access-denied.svg?react'
import { MMButton } from '@components'
import cn from 'classnames'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useHistory } from 'react-router-dom'
import styles from './AccessDenied.module.scss'

const AccessDenied = () => {
  const history = useHistory()

  return (
    <div className={cn(styles['access-denied'], 'access-denied-container')} data-test='access-denied-pane'>
      <div className={cn(styles['access-denied-body'], 'access-denied-body')}>
        <AccessDeniedIcon />

        <div className={cn(styles['access-denied-title'], 'access-denied-title')}>
          {tr('FRONTEND.ACCESS_DENIED.TITLE', 'Access denied')}
        </div>
        <div className={cn(styles['access-denied-message'], 'access-denied-message')}>
          {tr(
            'FRONTEND.ACCESS_DENIED.DESCRIPTION',
            'Sorry, but it seems that you cannot access this area because your account does not have the right to view this page.'
          )}
        </div>
      </div>

      <div className={cn(styles['access-denied-footer'], 'access-denied-footer')}>
        <MMButton
          type='button'
          size='large'
          variant='alternative'
          caption={tr('FRONTEND.ACCESS_DENIED.BACK_BUTTON', 'Back to overview')}
          onClick={() => history.push(paths.dashboard())}
          data-test='button-back'
          fullWidth
        />
      </div>
    </div>
  )
}

export default AccessDenied
